import request from '@/utils/request'

/**
 * 列出可加入打款批次的结款批次(已审核 + 未加入打款批次)
 */
export function listAvailablePaymentBatches() {
  return request({
    url: '/dispatcher/paymentbatches/available-batches',
    method: 'get'
  })
}

/**
 * 创建打款批次
 * @param {Object} data { pay_channel, settlement_batch_ids, remark }
 */
export function createPaymentBatch(data) {
  return request({
    url: '/dispatcher/paymentbatches/create',
    method: 'post',
    data
  })
}

/**
 * 打款批次列表
 * @param {Object} params { status, pay_channel, page, size }
 */
export function listPaymentBatches(params) {
  return request({
    url: '/dispatcher/paymentbatches/list',
    method: 'get',
    params
  })
}

/**
 * 打款批次详情
 * @param {Number} id
 */
export function getPaymentBatchDetail(id) {
  return request({
    url: '/dispatcher/paymentbatches/detail',
    method: 'get',
    params: { id }
  })
}

/**
 * 确认打款
 * @param {Object} data { id, remark }
 */
export function confirmPaymentBatch(data) {
  return request({
    url: '/dispatcher/paymentbatches/confirm',
    method: 'post',
    data
  })
}

/**
 * 取消打款批次
 * @param {Object} data { id, reason }
 */
export function cancelPaymentBatch(data) {
  return request({
    url: '/dispatcher/paymentbatches/cancel',
    method: 'post',
    data
  })
}